<template>
  <div v-if='enabled'>
    <h4>{{ label }}</h4>
    <check-list v-model="selectedItems" :items="listItems" />
  </div>
</template>

<script>
import CheckList from '../../components/ui-elements/check-list'
import mixins from './mixins'

let allValues = {} // Used to store a copy of the full list of options

export default {
  name: 'generic-filter-check-list',
  components: {
    'check-list': CheckList
  },
  mixins: [
    mixins
  ],
  props: {
    'products': {
      type: Array,
      requried: true
    },
    'filter': {
      type: Object,
      required: true
    },
    'value': {
      type: Object,
      required: true
    }
  },
  computed: {
    enabled: function () {
      return (this.selectedItems.length > 0)
    },
    selectedItems: {
      get () {
        return this.value[ this.filter.filterBy ]
      },
      set (v) {
        // The first time the selected items would be changed, save a backup copy of all options
        if (Object.entries(allValues).length === 0)  allValues = JSON.parse(JSON.stringify(this.value[ this.filter.filterBy ]))

        let newValue = Object.assign({}, this.value)
        newValue[ this.filter.filterBy ] = v

        // If the selected items list would be emptied completely, which would set enabled = false above, instead restore the full list from the backup
        if (Object.entries(newValue[ this.filter.filterBy ]).length === 0) newValue[ this.filter.filterBy ] = JSON.parse(JSON.stringify(allValues))
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .category-filter {
        position: relative;
        min-height: 4em;
        margin: 1em 0;
    }
    .range-slider {
        padding: 1em;

        .range-slider-label {
            position: relative;
            color: var(--main-primary);

            .minimum {
                text-align: left;
                float: left;
                font-weight: bold;
            }
            .maximum {
                text-align: right;
                float: right;
                font-weight: bold;
            }
        }
       ::v-deep .vue-slider-component {
            .vue-slider-process {
                background-color: var(--main-primary);
            }
            .vue-slider-tooltip {
                display: none;
                background-color: var(--main-primary);
                border-color: var(--main-primary);
            }
        }
    }
</style>
